import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

interface MaintenanceConfig {
  isMaintenanceMode: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService {
  private configUrl = 'assets/maintenance-config.json';

  constructor(private http: HttpClient) {}

  getConfig(): Observable<MaintenanceConfig> {
    var randomString = this.generateRandomString(30);
    return this.http.get<MaintenanceConfig>(
      `${this.configUrl}?qs=${randomString}`
    );
  }

  generateRandomString(length: number) {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }
}
